<script lang='ts' setup>

</script>

<template>
  <div class="h-full">
    <slot />
  </div>
</template>

<style lang='scss' scoped></style>
